import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { AppStore } from '@app/shared/store/app-store';

export const permissionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const appStore = inject(AppStore);

  return toObservable(appStore.isAccessibleRoutesDoneLoading).pipe(
    filter(isDone => isDone),
    map(() => {
      if (appStore.isRouteAccessible(state.url)) {
        return true;
      }
      router.navigate(['']);
      return false;
    })
  );
};
